exports.graduationRange = [-9, 4]
exports.cylinderRange = [-2.75, -0.75]
exports.axisRange = [10, 180]

exports.formatter = Intl.NumberFormat('es-AR', {
	minimumFractionDigits: 2,
	signDisplay: 'exceptZero',
})

exports.generateSequence = function (start, end, increment = 0.25) {
	const sequence = []
	if (start < end) {
		for (let i = start; i <= end; i += increment) {
			sequence.push(i)
		}
	} else {
		for (let i = start; i >= end; i -= increment) {
			sequence.push(i)
		}
	}
	return sequence
}

exports.formatSequence = function (sequence, type) {
	const formatFunction =
		type === 'degrees'
			? (s) => ({ text: s + '°', value: s })
			: (s) => ({ text: exports.formatter.format(s), value: s })
	return sequence.map(formatFunction)
}

exports.getGraduationSequence = function (start, end, increment = 0.25) {
	return exports.formatSequence(exports.generateSequence(start, end, increment), 'sign')
}

exports.getGraduationDegrees = function (start, end, increment = 10) {
	return exports.formatSequence(exports.generateSequence(start, end, increment), 'degrees')
}

/**
 * Sorts an array by absolute value
 * @param {Array<{text: string, value: number}>} graduations
 * @returns {Array<{text: string, value: number}>}
 */
exports.orderByAbsoluteValue = function (graduations) {
	return graduations.sort((a, b) => Math.abs(a.value) - Math.abs(b.value))
}

exports.withCache = function (func) {
	const cache = new Map()

	return function (...args) {
		const key = args.join(',')

		if (cache.has(key)) return cache.get(key)

		const result = func(...args)
		cache.set(key, result)
		return result
	}
}

function sortSequence(sequence, order = 'asc') {
	if (order === 'asc') return sequence.sort()
	return sequence.sort((a, b) => b - a)
}
